// extracted by mini-css-extract-plugin
module.exports = {"flexmargin":"_2m5JcDkD3dlVfpuxa9vxe9","vertical":"_2kBkU_qaewxXr0-EWTNGZ4"};